import { RouteObject } from "react-router"
import { ClienteList } from "./cliente.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { PeopleRounded } from "@mui/icons-material"

export enum PathRotaCliente {
    clientes = "/clientes"
}

const routerCliente: RouteObject = {
    path: PathRotaCliente.clientes,
    element: <ClienteList/>,
}


export const navigationToClienteView = ()=> rotas.navigate(PathRotaCliente.clientes)

export function startRouterCliente(){
    const menu:MainMenu = {
        text:"Clientes",
        icon:<PeopleRounded />,
        eventOnClick:navigationToClienteView
    }
    menuRotas.push(menu);
    return routerCliente
}